module.exports = __webpack_public_path__ + "static/media/113.fc12d59b.jpg";